@if (reordering()) {
  <th class="column-type-reorder"></th>
}

@for (column of columns(); track column.key) {
  <th
    pFrozenColumn
    [frozen]="valueOrDefault(column.frozen, false)"
    [columnWidth]="column.width"
    [column]="column"
    [ngClass]="[column | columnTypeCssClass, column | columnKeyCssClass]"
    [pSortableColumnDisabled]="!column.sortable"
    [pSortableColumn]="$any(column.sortKey | toString)"
    app-table-header-cell
    appColumnWidth></th>
}

<ng-container>
  <th
    [alignFrozen]="appendLabels() ? 'left' : 'right'"
    class="column-type-actions"
    pFrozenColumn>
    @if (appendLabels()) {
      <span class="p-datatable-label">Ustawienia</span>
    }
    <app-table-header-item-action
      (sortClearEvent)="sortClearEvent.emit($event)" />
  </th>
</ng-container>
